export type UserRole = 'ADMIN' | 'AVANZADO' | 'GESTION' | 'CONTRAPARTE' | 'OPERADOR' | 'VISUALIZADOR';

export interface MockUser {
    email: string;
    password?: string;
    name: string;
    role: UserRole;
}

/**
 * MATRIZ DE ROLES TIMBERFLOW v20.0
 * Define qué correos electrónicos tienen privilegios administrativos automáticos
 * si no existe un registro previo en Firestore.
 */
export const ROLE_EMAILS: Record<UserRole, string[]> = {
  ADMIN: [
    'operaciones@rollizos.cl',
    'rodrigo.vargas@rollizos.app',
    'admin@rollizos.app',
    'operaciones.dicar2025@gmail.com',
    'angelica.chacon@tromex.cl',
    'rodrigo.vargas.m@outlook.com',
  ],
  AVANZADO: [
    'customer@rollizos.cl',
    'supervisor@rollizos.app',
  ],
  GESTION: [
    'oficina@rollizos.app',
    'patio.gestion@rollizos.cl',
  ],
  CONTRAPARTE: [
    'inspector@rollizos.app',
    'contraparte.terminal@rollizos.cl',
    'contrapartedicar@gmail.com',
    'luis.briones@tromex.cl',
    'recepcion1@tromex.cl',
    'recepcion2@tromex.cl',
  ],
  OPERADOR: [
    'tromex@rollizos.app',
    'tarjador@rollizos.cl',
    'tarjadicar2@gmail.com',
  ],
  VISUALIZADOR: [
    'consulta@rollizos.cl',
    'auxiliar@rollizos.app',
  ],
};
